// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__2WeS9","active":"Navbar_active__WJfZi","menu":"Navbar_menu__u4P8M","options":"Navbar_options__OD+Bd"};